import { BAIDU_MARKER_URL } from './baidu.constants';

export function getBaiduMapURL({ latitude, longitude }) {
  return `${BAIDU_MARKER_URL}?location=${longitude},${latitude}&output=html`;
}
